import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

import RobotRegister from './RobotRegister';           
import robotPng from '../../assets/robot.png';   

const Register = () => {
  const { register, verifyEmail, user } = useAuth();
  const navigate = useNavigate();

  return (
    <RobotRegister
      robotImage={robotPng}                            
      register={register}
      verifyEmail={verifyEmail}
      user={user}
      onNavigate={(path) => navigate(path)}
    />
  );
};

export default Register;
